module.exports = __webpack_public_path__ + "assets/img/template-ad-3.8dbd0da5.png";